import { render, staticRenderFns } from "./InventorySelect.vue?vue&type=template&id=3546bf5b&"
import script from "./InventorySelect.vue?vue&type=script&lang=js&"
export * from "./InventorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports